import ZmenaGestoraPage from './ZmenaGestoraPage';

export default ZmenaGestoraPage;
